import { render } from "./OrganizationalStructure.vue?vue&type=template&id=33db7a5b"
import script from "./OrganizationalStructure.vue?vue&type=script&lang=js"
export * from "./OrganizationalStructure.vue?vue&type=script&lang=js"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__